import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  formatExpiry,
  getValuesByIds,
  questionIpInitialValues,
  questionIpMandatoryFields,
  questionIpProperties,
  questionIpValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useLazyQuery, useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import {
  CREATE_BATCH,
  UPDATE_BATCH,
} from "utils/graphql/services/entities/mutations";
import { getQueryParam, isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { GET_BATCH_LIST } from "utils/graphql/services/entities/queries";
import { useEffect, useState } from "react";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import LoadingButton from "@mui/lab/LoadingButton";
import { GET_COLLEGE_IPS } from "utils/graphql/services/operations/queries";
import { UPDATE_COLLEGE_IP } from "utils/graphql/services/operations/mutations";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getCollegeFromStateId, getCollegeFromStateIdForUp } from "utils/metadata-split/depedentApiFetch";
import { areArraysEqual, setReactFormValues } from "pages/configue/constants";

export const QuestionIPUpdate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    questionIpInitialValues,
    questionIpValidationSchema,
    ""
  );
  const dispatch = useAppDispatch();
  const history = useHistory();
  const match: any = useRouteMatch();
  const location = useLocation();
  const objectId = getQueryParam("id", location);
  const [fetchAll, setFetchAll] = useState(true);
  const [initialCall, setinitialCall] = useState(false);
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const [getCollegeIPs, { loading, error, data }] = useLazyQuery(
    GET_COLLEGE_IPS,
    {
      client: entitesClient,
    }
  );

  const [
    updateCollegeIp,
    { loading: loadingUp, error: errorUp, data: dataUp },
  ] = useMutation(UPDATE_COLLEGE_IP, {
    client: entitesClient,
  });

  const updateMetaData = async (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    await dispatch(metadataSuccess(metadataList));

    if (metaKey == "college_list" && listData?.length == 0) {
      setValue("college_id", "");
    }
  };

  const updateMetaDataMs = async (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    await dispatch(metadataSuccess(metadataList));
     if (metaKey == "college_list" && listData?.length == 0) {
      setValue("college_id", "");
    }
    setFetchAll(false);
  };

  useEffect(() => {
    if (fetchAll && watch()?.state_id?.length > 0) {
      (async () => {
        setinitialCall(true);
        const call1 = await getCollegeFromStateIdForUp(
          watch()?.state_id,
          updateMetaDataMs
        );
        updateMetaDataMs(call1[0], call1[1]);
      })();
    }
  }, [ watch()?.state_id]);

  useEffect(() => {
    if (!fetchAll) {
      (async () => {
        await getCollegeFromStateId(watch()?.state_id, updateMetaData);
      })();
    }
  }, [watch()?.state_id]);


  useEffect(() => {
    if (metaData?.college_list?.length > 0 && !isLoad) {
      let matchedVales = setReactFormValues(
        metaData,
        "college_list",
        watch()?.college_id,
        "college_id"
      );
      let isEqual = areArraysEqual(watch()?.college_id, matchedVales);
      if (!isEqual) {
        setValue("college_id", matchedVales);
      }
    }
  }, [metaData?.college_list]);

  const handleUpdateBatch = async () => {
    const collegeName = getValuesByIds(
      [watch()?.college_id],
      metaData?.college_list,
      "college_name",
      "college_id"
    );
    const stateName = getValuesByIds(
      [watch()?.state_id],
      metaData?.state_list,
      "state_name",
      "state_id"
    );
    try {
      const response: any = await updateCollegeIp({
        variables: {
          input: {
            id: +objectId,
            stateId: watch()?.state_id,
            stateName: stateName[0],
            collegeObjectId: watch()?.college_id,
            collegeName: collegeName[0],
            ipAddress: watch()?.ipAddress,
            status: watch()?.status,
            expiry: formatExpiry(watch()?.expiry),
          },
        },
      });

      if (response?.data?.updateCollegeIpAddress?.success) {
        dispatch(
          snackbarRequest({
            message:
              `${response?.data?.updateCollegeIpAddress?.message}` ||
              "Updated questionIP successfully",
          })
        );
        history.replace(`/operations/question_ip`);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.errorReason}`,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(snackbarRequest({ message: `${err}`, type: "error" }));
    }
  };

  useEffect(() => {
    if (data?.getCollegeIpAddresses) {
      const { getCollegeIpAddresses } = data;
      if (!isEmpty(getCollegeIpAddresses[0])) {
        setValue("college_id", getCollegeIpAddresses[0]?.collegeObjectId);
        setValue("state_id", getCollegeIpAddresses[0]?.stateId);
        setValue("ipAddress", getCollegeIpAddresses[0]?.ipAddress);
        setValue("status", getCollegeIpAddresses[0]?.status);
        setValue("expiry", getCollegeIpAddresses[0]?.expiry);
      }
    }
  }, [data]);

  useEffect(() => {
    getCollegeIPs({
      variables: {
        filter: {
          id: +objectId,
        },
      },
    });
  }, []);

  return (
    <div>
      <TypographyHeading>Update Branch IP Config</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={questionIpProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              loading={loadingUp}
              sx={{
                width: "180px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleUpdateBatch}
               disabled={
                !isFieldsValidate(errors, questionIpMandatoryFields, getValues)
              }
            >
              Update Config
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
